(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-juju"] && !Shopify.designMode) return;
  try {
    
// Prices are in the shop's presentment-currency minor units.
function selectJujuProducts(items, audience, use, position, giftMode = false) {
  const seen = new Set();
  const eligible = items.filter(item => {
    const itemUses = item.uses.split(',').map(v => v.trim());
    const useMatches = itemUses.includes(use) || (use === 'hiking' && (itemUses.includes('mountain') || itemUses.includes('landscape')));
    if (!Number.isFinite(item.price) || item.price <= 0 || !useMatches || !['both', audience].includes(item.audience) || seen.has(item.id)) return false;
    seen.add(item.id); return true;
  });
  const preferred = /nikon|gpo|vortex|pentax|bushnell|hikmicro|bresser|urikan|vanguard|zeiss/i;
  function fit(p) {
    if (p.kind === 'scope') return use === 'stars' ? 4 : 1;
    const title = (use === 'sea' && p.handle ? p.handle.replace(/-/g, ' ') : (p.title || p.handle || '')).toLowerCase().replace(/,/g, '.');
    const format = title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+)/);
    const m = format ? Number(format[1]) : 0, d = format ? Number(format[2]) : 0;
    if (!m || !d) return 2;
    if (audience === 'child') return m <= 8 && d <= 30 ? 4 : d <= 32 ? 3 : 1;
    if (use === 'stars') return d >= 50 && m >= 10 && m <= 12 ? 4 : d >= 50 && m <= 15 ? 3 : 2;
    if (use === 'sea') {
      if (m === 7 && d === 50 && /marine|navigator|regatta|h2o/.test(title)) return 5;
      return m <= 8 && /marine|navigator|regatta|h2o/.test(title) ? 4 : m <= 8 ? 3 : 2;
    }
    if (use === 'hiking') return (m === 8 || m === 10) ? (d <= 32 ? 4 : d <= 42 ? 3 : 2) : 1;
    if (use === 'mountain') return (m === 8 || m === 10) ? (d <= 32 ? 4 : d <= 43 ? 3 : 2) : 1;
    if (use === 'hunt_stalk') {
      if ((m === 8 || m === 10) && d >= 40 && d <= 43) return 4;
      if ((m === 8 || m === 10) && d >= 30 && d <= 32) return 3;
      return 1;
    }
    if (use === 'birds') return d >= 30 && d <= 43 && m >= 8 && m <= 10 ? 4 : d <= 30 && m <= 10 ? 3 : d >= 40 && m <= 10 ? 2 : 1;
    if (use === 'hunt_hide') {
      if (m === 8 && d >= 50 && d <= 56) return 4;
      if (m === 10 && d >= 50 && d <= 56) return 3;
      if ((m === 8 || m === 10) && d >= 40 && d <= 43) return 2;
      return 1;
    }
    if (use === 'hunt_water') {
      if ((m === 7 && d === 50) || (m === 8 && d >= 50 && d <= 56)) return 4;
      if (m === 8 && d >= 40 && d <= 43) return 3;
      return 1;
    }
    if (use === 'show') return m <= 8 && d <= 32 ? 4 : m <= 10 ? 3 : 2;
    if (use === 'shore' || use === 'landscape') return m >= 8 && m <= 10 && d <= 43 ? 4 : m <= 12 ? 3 : 2;
    return 3;
  }
  const priority = p => preferred.test(p.vendor || p.title || p.handle || '') ? 1 : 0;
  const ceiling = position * 5000;
  const birdGuides = {
    12: [/legend ultra/i, /viper hd 10\s*[x×]\s*42/i, /engage edx 10\s*[x×]\s*42/i],
    13: [/viper hd 8\s*[x×]\s*42/i, /passion 8\s*[x×]\s*56/i, /viper hd 10\s*[x×]\s*42/i, /legend ultra/i],
    14: [/viper hd 10\s*[x×]\s*50/i, /passion 10\s*[x×]\s*56/i, /viper hd 8\s*[x×]\s*42/i, /passion 8\s*[x×]\s*56/i],
    15: [/wildlife 8\s*[x×]\s*42/i, /viper hd 10\s*[x×]\s*50/i, /passion 10\s*[x×]\s*56/i],
    16: [/lynx hd\+? 8\s*[x×]\s*42/i, /wildlife 8\s*[x×]\s*42/i],
    17: [/lynx hd\+? 10\s*[x×]\s*42/i, /lynx hd\+? 10\s*[x×]\s*50/i, /lynx hd\+? 8\s*[x×]\s*42/i],
    19: [/conquest hdx 8\s*[x×]\s*32/i, /lynx hd\+? 10\s*[x×]\s*42/i, /lynx hd\+? 10\s*[x×]\s*50/i],
    20: [/conquest hdx 10\s*[x×]\s*32/i, /apc 10\s*[x×]\s*30/i, /conquest hdx 8\s*[x×]\s*32/i]
  };
  const guideIndex = (p, guide) => {
    if (!guide) return 999;
    const title = `${p.title || ''} ${p.handle || ''}`;
    const index = guide.findIndex(pattern => pattern.test(title));
    return index < 0 ? 999 : index;
  };
  // Compare equally priced models on suitability, then favour the closer budget band.
  // A cheap specialist must not displace an appropriate model hundreds of euros closer
  // to the customer's stated ceiling.
  const band = p => Math.floor((p.price - 1) / 5000);
  const rank = (a,b) => {
    if (use === 'sea' && fit(a) !== fit(b)) return fit(b) - fit(a);
    if (use === 'hunt_stalk') {
      const stalkIndex = p => {
        const title = `${p.title || ''} ${p.handle || ''}`.toLowerCase().replace(/,/g, '.');
        const format = title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+)/);
        const m = format ? Number(format[1]) : 0, d = format ? Number(format[2]) : 0;
        if (m === 8 && d >= 40 && d <= 43) return 0;
        if (m === 10 && d >= 40 && d <= 43) return 1;
        if (m === 8 && d >= 30 && d <= 32) return 2;
        if (m === 10 && d >= 30 && d <= 32) return 3;
        return 9;
      };
      const guided = stalkIndex(a) - stalkIndex(b);
      if (guided) return guided;
    }
    if (use === 'hunt_hide') {
      const hideIndex = p => {
        const title = `${p.title || ''} ${p.handle || ''}`.toLowerCase().replace(/,/g, '.');
        const format = title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+)/);
        const m = format ? Number(format[1]) : 0, d = format ? Number(format[2]) : 0;
        if (m === 8 && d === 56) return 0;
        if (m === 8 && d === 50) return 1;
        if (m === 10 && d >= 50 && d <= 56) return 2;
        if (m === 8 && d >= 40 && d <= 43) return 3;
        if (m === 10 && d >= 40 && d <= 43) return 4;
        return 9;
      };
      const guided = hideIndex(a) - hideIndex(b);
      if (guided) return guided;
    }
    if (use === 'hunt_water') {
      const waterIndex = p => {
        const title = `${p.title || ''} ${p.handle || ''}`.toLowerCase().replace(/,/g, '.');
        const format = title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+)/);
        const m = format ? Number(format[1]) : 0, d = format ? Number(format[2]) : 0;
        if ((m === 7 && d === 50) || (m === 8 && d === 56)) return 0;
        if (m === 8 && d >= 50 && d <= 56) return 1;
        if (m === 8 && d >= 40 && d <= 43) return 2;
        return 9;
      };
      const guided = waterIndex(a) - waterIndex(b);
      if (guided) return guided;
    }
    if (use === 'hiking') {
      const hikingIndex = p => {
        const title = `${p.title || ''} ${p.handle || ''}`.toLowerCase();
        if (/bushnell a1 8\s*[x×]\s*25/.test(title)) return 0;
        if (/bushnell a1 10\s*[x×]\s*25/.test(title)) return 1;
        if (/8\s*[x×]\s*(25|26|30|32)/.test(title)) return 2;
        if (/10\s*[x×]\s*(25|26|30|32)/.test(title)) return 3;
        return 4;
      };
      const guided = hikingIndex(a) - hikingIndex(b);
      if (position <= 5 && guided) return guided;
      const budgetBand = band(b) - band(a);
      if (budgetBand) return budgetBand;
      if (guided) return guided;
    }
    if (use === 'hunt_hide' && position === 9) {
      const hide450Index = p => /gpo passion ed 8\s*[x×]\s*42/i.test(`${p.title || ''} ${p.handle || ''}`) ? 0 : 1;
      const guided = hide450Index(a) - hide450Index(b);
      if (guided) return guided;
    }
    if (use === 'birds' && birdGuides[position]) {
      const guided = guideIndex(a, birdGuides[position]) - guideIndex(b, birdGuides[position]);
      if (guided) return guided;
    }
    return band(b)-band(a) || fit(b)-fit(a) || b.price-a.price || priority(b)-priority(a) || String(a.id).localeCompare(String(b.id));
  };
  function choose(pool, count) {
    if (use !== 'stars') return pool.slice(0,count);
    const binocular = pool.find(p=>p.kind !== 'scope'), scope = pool.find(p=>p.kind === 'scope');
    if (!binocular || !scope) return pool.slice(0,count);
    const pair = [binocular,scope];
    return [...pair,...pool.filter(p=>!pair.includes(p))].slice(0,count);
  }
  const suitable = eligible.filter(p => fit(p) >= 2);
  if (position === 25) return { matches: choose(suitable.slice().sort((a,b) => fit(b)-fit(a) || priority(b)-priority(a) || b.price-a.price),3), premium: true, alternative: false };
  const under = suitable.filter(p => p.price <= ceiling).sort(rank);
  const huntHideStarterUpgrade = use === 'hunt_hide' && position === 3;
  const upgradePercent = 120;
  const upgrades = suitable.filter(p => p.price > ceiling && p.price * 100 <= ceiling * upgradePercent).sort((a,b) => {
    if (use === 'sea' && fit(a) !== fit(b)) return fit(b) - fit(a);
    if (huntHideStarterUpgrade) {
      const starterIndex = p => /legend e[- ]?series/i.test(`${p.title || ''} ${p.handle || ''}`) ? 0 : 1;
      const starter = starterIndex(a) - starterIndex(b);
      if (starter) return starter;
    }
    if (use === 'birds' && (birdGuides[position] || birdGuides[position + 1])) {
      const upgradeIndex = p => {
        const current = guideIndex(p, birdGuides[position]);
        if (current < 999) return current;
        const next = guideIndex(p, birdGuides[position + 1]);
        return next < 999 ? 100 + next : 999;
      };
      const guided = upgradeIndex(a) - upgradeIndex(b);
      if (guided) return guided;
    }
    return fit(b)-fit(a) || a.price-b.price || priority(b)-priority(a);
  });
  const upgrade = upgrades[0];
  if (under.length) return { matches: choose(under,2), upgrade, premium:false, alternative:false };
  if (use === 'night' && eligible.length) return { matches:[eligible.slice().sort((a,b)=>a.price-b.price)[0]], alternative:true, nightBudget:true, premium:false };
  if (upgrade) return { matches:[upgrade], alternative:true, premium:false };
  return { matches:[], alternative:false, premium:false, minimumPrice:eligible.length ? Math.min(...eligible.map(p=>p.price)) : undefined };
}

function initializeJuju(scope = document) {
  scope.querySelectorAll('[data-juju]').forEach(root => {
    const form = root.querySelector('[data-form]');
    if (!form || root.dataset.ready) return;
    root.dataset.ready = 'true';
    let steps = [...form.querySelectorAll('[data-step]')];
    const giftMode = new URLSearchParams(window.location.search).get('juju_mode') === 'gift';
    const next = form.querySelector('[data-next]');
    const back = form.querySelector('[data-back]');
    const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
    if (giftMode) {
      const [audienceStep, useStep, budgetStep] = steps;
      audienceStep.removeAttribute('data-step');
      audienceStep.hidden = false;
      audienceStep.disabled = false;
      useStep.append(audienceStep);
      steps = [budgetStep, useStep];
      root.querySelector('[data-journey-title]').textContent = labels.gift_title;
      root.querySelector('[data-journey-intro]').textContent = labels.gift_intro;
      root.querySelector('[id^="juju-budget-note-"]').textContent = labels.gift_budget_note;
      form.querySelector('[data-step-total]').textContent = '2';
    }
    const slider = form.elements.budget;
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:root.dataset.currency || 'EUR',maximumFractionDigits:2}).format(value / 100);
    const text = (key, values = {}) => Object.entries(values).reduce((str, [k,v]) => str.replaceAll('__'+k.toUpperCase()+'__',v), labels[key]);
    const budgetLabel = position => text(position === 25 ? 'over' : 'under', {price: money(position === 25 ? 120000 : position*5000)});
    function updateBudget() { const value=budgetLabel(Number(slider.value)); root.querySelector('[data-budget-value]').textContent=value;slider.setAttribute('aria-valuetext',value); }
    root.querySelector('[data-budget-first]').textContent=budgetLabel(1);
    root.querySelector('[data-budget-last]').textContent=budgetLabel(25);
    slider.addEventListener('input',updateBudget);updateBudget();
    const frames=['anim1.png?v=1716971903','anim3.png?v=1716971903','anim55.png?v=1717514550','anim3.png?v=1716971903','anim5.png?v=1716971904','anim6.png?v=1716971904'].map(name=>'https://cdn.shopify.com/s/files/1/0773/1016/5332/files/'+name);
    let step=0, timer=null;
    function showStep(n, focus = true) {
      step=n;steps.forEach((el,i)=>{el.hidden=i!==n;el.disabled=i!==n});back.hidden=n===0;
      next.textContent=n===steps.length-1?labels.results:labels.next;
      form.querySelector('[data-step-number]').textContent=String(n+1);if(focus)steps[n].querySelector('legend').focus();
      if(n===steps.length-1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) frames.forEach(src=>{const img=new Image();img.src=src;});
    }
    form.addEventListener('change',()=>{const selectedUse=form.elements.use.value;form.querySelector('[data-hunting]').hidden=selectedUse!=='hunt';const isSea=selectedUse==='sea';form.querySelector('[data-marine]').hidden=!isSea;form.elements.marine.disabled=!isSea;root.querySelector('[data-budget-note]').textContent=selectedUse==='night'?labels.night_budget_note:labels.budget_note;});
    back.addEventListener('click',()=>showStep(Math.max(0,step-1)));
    function revealResults() {
      clearInterval(timer);timer=null;root.querySelector('[data-thinking]').hidden=true;
      root.querySelector('[data-results]').hidden=false;root.querySelector('[data-result-heading]').focus();
    }
    form.addEventListener('submit',event=>{
      event.preventDefault();if(timer || !form.reportValidity())return;
      if(step<steps.length-1){showStep(step+1);return;}
      const audience=form.elements.audience.value, use=form.elements.use.value;
      const useKey=use==='hunt'?'hunt_'+form.elements.hunting.value:use==='sea'&&form.elements.marine.value==='shore'?'shore':use;
      const position=Number(slider.value), ceiling=position*5000;
      const items=[...root.querySelectorAll('template[data-product]')].map(t=>({id:t.dataset.productId,title:t.dataset.title,handle:t.dataset.handle,vendor:t.dataset.vendor,kind:t.dataset.kind,price:Number(t.dataset.price),uses:t.dataset.uses,audience:t.dataset.audience,template:t}));
      const selection=selectJujuProducts(items,audience,useKey,position,giftMode);
      const products=root.querySelector('[data-products]');products.replaceChildren();
      selection.matches.forEach(p=>products.append(p.template.content.cloneNode(true)));
      const upgrade=root.querySelector('[data-upgrade]');upgrade.hidden=!selection.upgrade;
      const upgradeProducts=root.querySelector('[data-upgrade-products]');upgradeProducts.replaceChildren();
      if(selection.upgrade){root.querySelector('[data-upgrade-note]').textContent=text('upgrade',{price:money(selection.upgrade.price),difference:money(selection.upgrade.price-ceiling)});upgradeProducts.append(selection.upgrade.template.content.cloneNode(true));}
      const empty=root.querySelector('[data-empty]');empty.hidden=selection.matches.length>0;empty.textContent=selection.minimumPrice?text('low_budget',{price:money(selection.minimumPrice)}):audience==='child'?labels.child_empty:giftMode?labels.gift_empty:labels.empty;
      const order=root.querySelector('[data-results-order]');order.hidden=!selection.matches.length || selection.alternative;
      order.textContent=selection.premium?labels.selection_open:labels.selection_budget;
      const alternative=root.querySelector('[data-alternative]');alternative.hidden=!selection.alternative;
      alternative.textContent=selection.alternative?text(selection.nightBudget?'night_budget':selection.matches[0].price===ceiling?'at_limit':'alternative',{price:money(selection.matches[0].price),difference:money(selection.matches[0].price-ceiling)}):'';
      root.querySelector('[data-child-note]').hidden=audience!=='child';
      root.querySelector('[data-reason]').textContent=selection.matches.length?(useKey==='stars'?labels.astro_reason:useKey==='shore'?labels.reason_shore:useKey.startsWith('hunt_')?labels['reason_'+useKey]:labels.reasons[use]):'';
      root.querySelector('[data-summary]').textContent=form.querySelector('input[name="use"]:checked').parentElement.textContent.trim()+(use==='sea'?' — '+form.elements.marine.selectedOptions[0].textContent:use==='hunt'?' — '+form.elements.hunting.selectedOptions[0].textContent:'')+' · '+budgetLabel(position);
      form.hidden=true;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){revealResults();return;}
      const thinking=root.querySelector('[data-thinking]'),owl=root.querySelector('[data-owl]');thinking.hidden=false;owl.src=frames[0];
      let index=0;timer=setInterval(()=>{index++;if(index>=frames.length){revealResults();return;}owl.src=frames[index];},250);
    });
    root.querySelector('[data-restart]').addEventListener('click',()=>{clearInterval(timer);timer=null;root.querySelector('[data-results]').hidden=true;root.querySelector('[data-thinking]').hidden=true;form.hidden=false;showStep(0)});
    root.addEventListener('shopify:section:unload',()=>clearInterval(timer));
    showStep(0, false);
    next.disabled=false;
  });
}
initializeJuju();
document.addEventListener('shopify:section:load',event=>initializeJuju(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
